import {
  AllocatableLoadSearchPage,
  AllocatableLoadSettingsFormPageRoute,
  CompanySettlementProfilePageRoute,
  CompanySettlementTicketComparePageRoute,
  ContainerExportFormPage,
  ContainerImportPage,
  createOtsRouter,
  DispatchRequestProfilePageRoute,
  ErrorPage,
  InvoiceProfilePageRoute,
  InvoiceSearchPage,
  MeterFlowVolumeFormPageRoute,
  MeterFlowVolumeReviewPageRoute,
  MeterFlowVolumeSearchPage,
  PipelineDataTablePage,
  PipelineFlowFormPageRoute,
  PipelineFlowSearchPage,
  PipelineFlowTransportSearchPage,
  PipelineFormPageRoute,
  PipelineGraphBuilderPageRoute,
  PipelineGraphViewPageRoute,
  PipelineProfilePageRoute,
  ProductionVolumeFormPageRoute,
  ProductionVolumeSearchPage,
  RegionProfilePageRoute,
  SettlementProfilePageRoute,
  TicketComparePageRoute,
  TicketLocationHistoryMapPageRoute,
  TicketProfilePageRoute,
  MeterImportPage, SiteSiteAssocImportPage, OpsDashboardPage
} from "@ots-frontend/ots-ui";
import {AppAccessManagementPage, HelpSupportPage, UserProfilePage} from "@ots-frontend/ots-ui-tw";
import {createBrowserRouter, createRoutesFromElements, Link, Navigate, Route, useNavigate} from "react-router-dom";
import {LoginPage} from "../pages/LoginPage/LoginPage";
import {AppOutlet} from "../app";
import {DailyDispatchRequestPage} from "../pages/DispatchRequestPage/DailyDispatchRequestPage";
import {UnauthorizedDispatchRequestPage} from "../pages/DispatchRequestPage/UnauthorizedDispatchRequestPage";
import {DispatchRequestFormPageRoute} from "../pages/DispatchRequestFormPage/DispatchRequestFormPage";
import {TicketsPage} from "../pages/TicketsPage/TicketsPage";
import {ContainerStatusPage} from "../pages/ContainerStatusPage/ContainerStatusPage";
import {InsightsPage} from "../pages/InsightsPage/InsightsPage";
import {Anchor} from "@mantine/core";
import {InsightsSearchPage} from "../pages/InsightsSearchPage/InsightsSearchPage";
import {VolumeInventorySearchPage} from "../pages/VolumeInventorySearchPage/VolumeInventorySearchPage";
import {IndexComponent} from "./IndexComponent";
import {
  ContainerDNUStatisticsSearchPage
} from "../pages/ContainerDNUStatisticsSearchPage/ContainerDNUStatisticsSearchPage";
import {ToolsPage} from "../pages/ToolsPage/ToolsPage";
import {PipelinePage} from "../pages/PipelinePage/PipelinePage";
import {PipelineInsightsSearchPage} from "../pages/PipelineInsightsSearchPage/PipelineInsightsSearchPage";
import {TruckingPage} from "../pages/TruckingPage/TruckingPage";
import {LoadsBySearchPage} from "../pages/LoadsBySearchPage/LoadsBySearchPage";
import {QuantityBySearchPage} from "../pages/QuantityBySearchPage/QuantityBySearchPage";
import {FinancialPage} from "../pages/FinancialPage/FinancialPage";
import {MapPage} from "../pages/MapPage/MapPage";
import {PipelineSettlementPage} from "../pages/PipelineSettlementPage/PipelineSettlementPage";
import {SettlementPage} from "../pages/SettlementPage/SettlementPage";
import {RejectsBySearchPage} from "../pages/RejectsBySearchPage/RejectsBySearchPage";
import {AvailableLoadsBySearchPage} from "../pages/AvailableLoadsBySearchPage/AvailableLoadsBySearchPage";
import {
  ExceedsNonPrimaryVolumeStatisticsSearchPage
} from "../pages/ExceedsNonPrimaryVolumeStatisticsSearchPage/ExceedsNonPrimaryVolumeStatisticsSearchPage";
import {ContainerStatusShutInPage} from "../pages/ContainerStatusShutInPage/ContainerStatusShutInPage";
import {HubGoAuthProvider} from "../auth/HubGoAuthProvider/HubGoAuthProvider";

const UserProfilePageRoute = () => {
  const navigate = useNavigate();

  return <UserProfilePage onManageNotifications={() => navigate("/notifications")}/>;
};

export const AppRouter = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<HubGoAuthProvider/>}>
        <Route path="/login" element={<LoginPage/>}/>
        <Route element={<AppOutlet/>}>
        <Route index element={<IndexComponent/>}/>

        <Route path="allocatable-loads/*" element={<IndexComponent/>}>
          <Route index element={<AllocatableLoadSearchPage/>}/>
        </Route>

        <Route path="map/*" element={<IndexComponent/>}>
          <Route index element={<MapPage/>}/>
        </Route>

        <Route path="ops/*" element={<IndexComponent/>}>
          <Route index element={<OpsDashboardPage/>}/>
        </Route>

        <Route path="requests/*" element={<IndexComponent/>}>
          <Route index element={<DailyDispatchRequestPage/>}/>
          <Route path="unauthorized" element={<UnauthorizedDispatchRequestPage/>}/>
          <Route
            path="profile"
            element={
              <DispatchRequestProfilePageRoute
                showAcceptRejectActions={false}
                showJobViewAction={false}/>
            }/>
          <Route path="form" element={<DispatchRequestFormPageRoute/>}/>
        </Route>

        <Route
          path="trucking/*"
          element={<IndexComponent/>}
          handle={{
            crumb: () => (
              <Anchor component={Link} to={`/trucking`} key="trucking">
                Trucking
              </Anchor>
            )
          }}>
          <Route index element={<TruckingPage/>}/>
          <Route path="tickets/*" element={<IndexComponent/>}>
            <Route
              index
              element={<TicketsPage/>}
              handle={{
                crumb: () => (
                  <Anchor component={Link} to={`/trucking/tickets`} key="trucking_tickets">
                    Tickets
                  </Anchor>
                )
              }}
            />
            <Route
              path="profile/*"
              element={<IndexComponent/>}
              handle={{
                crumb: () => (
                  <Anchor component={Link} to={`..`} key="ticket_profile">
                    Ticket
                  </Anchor>
                )
              }}>
              <Route index element={<TicketProfilePageRoute/>}/>
              <Route path="map" element={<TicketLocationHistoryMapPageRoute/>}/>
            </Route>
          </Route>
        </Route>

        <Route
          path="pipelines/*"
          element={<IndexComponent/>}
          handle={{
            crumb: () => (
              <Anchor component={Link} to={`/pipelines`} key="pipelines">
                Pipeline
              </Anchor>
            )
          }}>
          <Route index element={<PipelinePage/>}/>
          <Route
            path="insights/search"
            element={<PipelineInsightsSearchPage/>}
            handle={{
              crumb: () => (
                <Anchor component={Link} to={`/pipelines/insights/search`} key="pipeline_insights_search">
                  Historical
                </Anchor>
              )
            }}/>
          <Route path="data" element={<PipelineDataTablePage/>}/>
          <Route path="profile" element={<PipelineProfilePageRoute/>}/>
          <Route path="profile/graph-builder" element={<PipelineGraphBuilderPageRoute/>}/>
          <Route path="profile/graph" element={<PipelineGraphViewPageRoute/>}/>
          <Route path="form" element={<PipelineFormPageRoute/>}/>
          <Route path="settlement" element={<PipelineSettlementPage/>}/>

          <Route path="flows/*" element={<IndexComponent/>}>
            <Route index element={<PipelineFlowSearchPage/>}/>
            <Route path="form" element={<PipelineFlowFormPageRoute/>}/>
          </Route>

          <Route path="meter-flows/*" element={<IndexComponent/>}>
            <Route index element={<MeterFlowVolumeSearchPage/>}/>
            <Route path="review" element={<MeterFlowVolumeReviewPageRoute/>}/>
            <Route path="form" element={<MeterFlowVolumeFormPageRoute/>}/>
          </Route>

          <Route path="flow-tickets/*" element={<IndexComponent/>}>
            <Route index element={<PipelineFlowTransportSearchPage/>}/>
          </Route>
        </Route>

        <Route path="regions/profile" element={<RegionProfilePageRoute/>}/>

        <Route path="container-status/*" element={<IndexComponent/>}>
          <Route index element={<ContainerStatusPage/>}/>
          <Route path="shut-ins" element={<ContainerStatusShutInPage/>}/>
        </Route>

        <Route
          path="insights/*"
          element={<IndexComponent/>}
          handle={{
            crumb: () => (
              <Anchor component={Link} to={`/insights`} key="insights">
                Insights
              </Anchor>
            )
          }}>
          <Route index element={<InsightsPage/>}/>
          <Route
            path="search"
            element={<InsightsSearchPage/>}
            handle={{
              crumb: () => (
                <Anchor component={Link} to={`/insights/search`} key="insights_search">
                  Historical
                </Anchor>
              )
            }}/>
          <Route
            path="volume-inventory"
            element={<VolumeInventorySearchPage/>}
            handle={{
              crumb: () => (
                <Anchor component={Link} to={`/insights/volume-inventory`}
                        key="insights_volume_inventory">
                  Volume Inventory
                </Anchor>
              )
            }}
          />
          <Route
            path="available-loads-by"
            element={<AvailableLoadsBySearchPage/>}
            handle={{
              crumb: () => (
                <Anchor
                  component={Link}
                  to={`/insights/available-loads-by`}
                  key="insights_available_loads_by">
                  Avail. Loads By
                </Anchor>
              )
            }}
          />
          <Route
            path="container-dnu"
            element={<ContainerDNUStatisticsSearchPage/>}
            handle={{
              crumb: () => (
                <Anchor component={Link} to={`/insights/container-dnu`} key="insights_container_dnu">
                  Usable Containers
                </Anchor>
              )
            }}
          />
          <Route
            path="exceeds-non-primary-volume-by"
            element={<ExceedsNonPrimaryVolumeStatisticsSearchPage/>}
            handle={{
              crumb: () => (
                <Anchor
                  component={Link}
                  to={`/insights/exceeds-non-primary-volume-by`}
                  key="insights_exceeds_non_primary_volume_by">
                  High Bottoms By
                </Anchor>
              )
            }}
          />
          <Route
            path="loads-by"
            element={<LoadsBySearchPage/>}
            handle={{
              crumb: () => (
                <Anchor
                  component={Link}
                  to={`/insights/loads-by`}
                  key="insights_loads_by">
                  Loads By
                </Anchor>
              )
            }}
          />
          <Route
            path="rejects-by"
            element={<RejectsBySearchPage/>}
            handle={{
              crumb: () => (
                <Anchor
                  component={Link}
                  to={`/insights/rejects-by`}
                  key="insights_rejects_by">
                  Rejects By
                </Anchor>
              )
            }}
          />
          <Route
            path="quantity-by"
            element={<QuantityBySearchPage/>}
            handle={{
              crumb: () => (
                <Anchor
                  component={Link}
                  to={`/insights/quantity-by`}
                  key="insights_quantity_by">
                  Quantity By
                </Anchor>
              )
            }}
          />
        </Route>

        <Route path="settlement/*" element={<IndexComponent/>}>
          <Route index element={<SettlementPage/>}/>
          <Route
            path="profile/*"
            element={<IndexComponent/>}
            handle={{
              crumb: () => (
                <Anchor component={Link} to={`..`} key="settlement_profile">
                  Settlement
                </Anchor>
              )
            }}>
            <Route index element={<SettlementProfilePageRoute/>}/>
            <Route
              path="company/profile/*"
              element={<IndexComponent/>}
              handle={{
                crumb: () => (
                  <Anchor component={Link} to={`..`} key="company_settlement_profile">
                    Company Settlement
                  </Anchor>
                )
              }}>
              <Route index element={<CompanySettlementProfilePageRoute/>}/>
              <Route path="ticket-compare" element={<CompanySettlementTicketComparePageRoute/>}/>
            </Route>
          </Route>
        </Route>

        <Route path="financial/*" element={<IndexComponent/>}>
          <Route index element={<FinancialPage/>}/>
          <Route path="compare" element={<TicketComparePageRoute/>}/>
          <Route path="invoices/*" element={<IndexComponent/>}>
            <Route index element={<InvoiceSearchPage/>}/>
            <Route path="profile" element={<InvoiceProfilePageRoute/>}/>
          </Route>
        </Route>

        <Route path="directory" element={<ToolsPage/>}/>
        <Route path="app-access" element={<AppAccessManagementPage/>}/>

        <Route path="profile" element={<UserProfilePageRoute/>}/>
        <Route path="help" element={<HelpSupportPage/>}/>

        <Route path="production-volumes/*" element={<IndexComponent/>}>
          <Route index element={<ProductionVolumeSearchPage/>}/>
          <Route path="form" element={<ProductionVolumeFormPageRoute/>}/>
        </Route>

        <Route path="export/*" element={<IndexComponent/>}>
          <Route path="containers" element={<ContainerExportFormPage/>}/>
        </Route>

        <Route path="import/*" element={<IndexComponent/>}>
          <Route path="containers" element={<ContainerImportPage/>}/>
          <Route path="meters" element={<MeterImportPage/>}/>
          <Route path="site-site-assocs" element={<SiteSiteAssocImportPage/>}/>
        </Route>

        <Route path="allocatable-load-settings/form" element={<AllocatableLoadSettingsFormPageRoute/>}/>

        {createOtsRouter()}

        <Route path="*" element={<ErrorPage/>}/>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to={"/"} replace/>}/>
    </>
  ),
  {
    basename: import.meta.env.BASE_URL
  }
);
